import React from 'react';

import { cn } from 'helpers/classnames';

interface ShowSelectedHashtagsProps {
  selectedHashtags?: string[];
  hashtagsHandler?: () => void;
  cssClasses: {
    editButtonCss?: string;
    selectedTagsCss: string;
    noSelectedTagsCss: string;
  };
}

export const ShowSelectedHashtags = ({ selectedHashtags, hashtagsHandler, cssClasses }: ShowSelectedHashtagsProps) => (
  <div
    className={cn(cssClasses.selectedTagsCss, {
      [cssClasses.noSelectedTagsCss]: !selectedHashtags?.length
    })}
  >
    {selectedHashtags?.map(selectedHashtag => <span key={selectedHashtag}>#{selectedHashtag}</span>)}
    {hashtagsHandler && <button type="button" className={cssClasses.editButtonCss} onClick={hashtagsHandler} />}
  </div>
);

export default ShowSelectedHashtags;
